/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Config from 'theme/config'
import HttpProvider from '@/services/HttpProvider'

export const phoneNumber = {
  getMessage: field => `${field} is not a valid phone number`,
  validate (value) {
    if (value) {
      // var re = /^(00|\+)39\d{6,12}$/
      return /^\+?\d{6,16}$/.test(value)
    } else {
      return true
    }
  }
}

export const passwordM = {
  getMessage: field => `${field} need at least 1 Lower Case, Upper Case and Digits`,
  validate (value) {
    if (value) {
      return /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).*$/.test(value)
    } else {
      return true
    }
  }
}

export const VAT = {
  getMessage: field => `invalid VAT`,
  validate (value) {
    if (value) {
      // check VAT if is not a fiscal code, MOS behaviour
      let fiscalCodeCheck = /^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i.test(value)
      return fiscalCodeCheck === true
        ? fiscalCodeCheck
        : /^[A-Za-z]{0,4}(?=.{2,12}$)[-_\s0-9]*(?:[a-zA-Z][-_\s0-9]*){0,2}$/.test(value)
    } else {
      return true
    }
  }
}

export const fiscalCode = {
  getMessage: field => `invalid fiscal code`,
  validate (value) {
    if (value) {
      // check fiscalCode if is not VAT, MOS behaviour
      let vatCodeCheck = /^[A-Za-z]{0,4}(?=.{2,12}$)[-_\s0-9]*(?:[a-zA-Z][-_\s0-9]*){0,2}$/.test(value)
      return vatCodeCheck === true
        ? vatCodeCheck
        : /^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i.test(value)
    } else {
      return true
    }
  }
}

export const requireTrue = {
  getMessage: field => `required field`,
  validate (value) {
    return value === true
  }
}

export const uniqueEmail = {
  getMessage: field => `${field} duplicated`,
  validate (value) {
    if (process.client) {
      let $store = global.$store
      return HttpProvider.post(
        Config.API.users.emailAvailable.replace(
          '{{storeViewCode}}', $store.state.ui.storeViewCode
        ),
        { customerEmail: value },
        {
          headers: {
            'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`
          }
        })
        .then(res => {
          return res.data
        })
    } else {
      return false
    }
  }
}

export function replaceParameter (string, parameters) {
  let tmpString = string
  if (parameters) {
    let paramsLength = parameters.length || Object.keys(parameters).length
    if (paramsLength > 1) {
      let regex
      for (let i in parameters) {
        regex = new RegExp(`%${i}`, 'g')
        tmpString = tmpString.replace(regex, parameters[i])
      }
    } else if (paramsLength === 1) {
      let regex = new RegExp(`%[0-9]`, 'g')
      tmpString = tmpString.replaceAll(regex, parameters[0])
    }
  }
  return tmpString
}

export const dob = {
  getMessage: field => `You have at least of 18 years`,
  validate (value, arg) {
    if (value) {
      let limit = arg && arg.length ? arg[0] : 18
      let today = new Date()
      let birthDate = new Date(value)
      let age = today.getFullYear() - birthDate.getFullYear()
      let m = today.getMonth() - birthDate.getMonth()
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
      }
      return age >= limit && age <= 130
    } else {
      return true
    }
  }
}

export default {
  VAT,
  fiscalCode,
  passwordM,
  phoneNumber,
  requireTrue,
  uniqueEmail,
  dob
}
